<div class="main">
  <div class="row">
    <div class="column twelve">
      <h2 class="heading-sub-page">Are you sure you want to opt out?</h2>
      <p class="summary">
        If so, we'll start sending your policy documents via standard mail. Any discounts associated
        with paperless policy documents will also be removed.
      </p>
    </div>
  </div>
  <div class="row callToAction">
    <span class="md-float-right">
      <a class="pad-horizontal-20" (click)="cancel()" data-cy="unenrollGoPaperlessBackLink">Back</a>
      <button
        ds-button
        type="button"
        (click)="unenroll()"
        [disabled]="!(roleService.isAuthorized('unregpaperlesspolicydocs_submit') | async)"
        data-cy="unenrollGoPaperlessOptOutBtn"
      >
        Opt Out
      </button>
    </span>
  </div>
</div>
